import React from 'react';
import { Zap } from 'lucide-react';
import RexVoiceLive from '../components/RexVoiceLive';

/**
 * RexVoicePage (/rex/voice) — dedicated cathedral for the live voice channel
 * with Rex. Architect directive · Feb 2026 · Sovereign Spec §IV.
 */

const RexVoicePage = () => (
  <main
    data-testid="rex-voice-page-root"
    style={{
      minHeight: '100vh',
      background:
        'radial-gradient(ellipse at top, rgba(255, 60, 100, 0.08) 0%, #0b0817 45%, #05030c 100%)',
      color: '#fff',
      padding: '3rem 1rem 6rem',
      fontFamily: 'Inter, system-ui, sans-serif',
    }}
  >
    <div style={{ maxWidth: 900, margin: '0 auto', display: 'grid', gap: '1.5rem' }}>
      <header style={{ textAlign: 'center' }}>
        <span
          style={{
            display: 'inline-flex', alignItems: 'center', gap: '0.45rem',
            padding: '0.4rem 1rem',
            background: 'rgba(255, 60, 100, 0.1)',
            border: '1px solid rgba(255, 60, 100, 0.45)',
            borderRadius: '999px',
            fontSize: '0.72rem', color: '#ff6478',
            letterSpacing: '0.18em', textTransform: 'uppercase', fontWeight: 700,
          }}
        >
          <Zap size={13} /> Rex Realtime · Voice channel
        </span>
        <h1
          data-testid="rex-voice-page-headline"
          style={{
            margin: '1rem 0 0.6rem', fontSize: 'clamp(2.2rem, 5vw, 3.4rem)', fontWeight: 900,
            lineHeight: 1.05,
            background: 'linear-gradient(135deg, #ff3c64 0%, #ffd700 60%, #ff8c00 100%)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
          }}
        >
          Speak with Rex
        </h1>
        <p style={{ color: '#a892b1', fontSize: '1.02rem', lineHeight: 1.6, maxWidth: 620, margin: '0 auto' }}>
          Live voice through xAI&apos;s Realtime channel · 24 kHz PCM · server-VAD · barge-in.
          If the realtime path can&apos;t open, Rex will fall back to Whisper transcription and
          text-to-speech so the conversation never breaks.
        </p>
      </header>

      <RexVoiceLive />

      <footer
        style={{
          textAlign: 'center', color: '#7a6e80', fontSize: '0.8rem',
          fontStyle: 'italic', marginTop: '1rem', lineHeight: 1.6,
        }}
      >
        🜂 Your voice never leaves this session — no recordings retained on the Aria node.
        Rex&apos;s sovereign prompt is preserved verbatim from REX_SOVEREIGN_CODE.md.
      </footer>
    </div>
  </main>
);

export default RexVoicePage;
